<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
  action: {
    type: String,
    default: 'pause',
    validator: value => ['pause', 'resume', 'stop'].includes(value),
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);

const i18nKeyMap = {
  pause: 'CONFIRM_PAUSE',
  resume: 'CONFIRM_RESUME',
  stop: 'CONFIRM_STOP',
};

const performAction = async id => {
  if (!id) return;

  try {
    await store.dispatch(`campaigns/${props.action}`, id);
    useAlert(t(`CAMPAIGN.${i18nKeyMap[props.action]}.API.SUCCESS_MESSAGE`));
  } catch (error) {
    useAlert(t(`CAMPAIGN.${i18nKeyMap[props.action]}.API.ERROR_MESSAGE`));
  }
};

const handleDialogConfirm = async () => {
  await performAction(props.selectedCampaign?.id);
  dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t(`CAMPAIGN.${i18nKeyMap[action]}.TITLE`)"
    :description="t(`CAMPAIGN.${i18nKeyMap[action]}.DESCRIPTION`)"
    :confirm-button-label="t(`CAMPAIGN.${i18nKeyMap[action]}.CONFIRM`)"
    @confirm="handleDialogConfirm"
  />
</template>
